export const asCleanOutlineIcon = {
  data: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path d="M120 1016V736q0-83 58.5-141.5T320 536h40V216q0-33 23.5-56.5T440 136h80q33 0 56.5 23.5T600 216v320h40q83 0 141.5 58.5T840 736v280H120Zm80-80h80V816q0-17 11.5-28.5T320 776q17 0 28.5 11.5T360 816v120h80V816q0-17 11.5-28.5T480 776q17 0 28.5 11.5T520 816v120h80V816q0-17 11.5-28.5T640 776q17 0 28.5 11.5T680 816v120h80V736q0-50-35-85t-85-35H320q-50 0-85 35t-35 85v200Zm320-400V216h-80v320h80Z"/>
    </svg>`,
  name: 'outline/clean'
};
